<template>
  <div class="content-box">
    <el-card class="box-card">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="机构名称 : ">
          <el-input v-model="formInline.enterpriseData" size="mini" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="searchTableData(1)" type="primary" size="mini">查询</el-button>
          <el-button @click="searchTableData(2)" size="mini">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="margin-bottom: 20px">
        <el-button @click="openDrawer(1)" size="mini">新增</el-button>
        <el-button @click="openDrawer(2)" size="mini">修改</el-button>
        <el-popconfirm
            style="padding: 10px"
            title="确定将选择数据删除？"
            @confirm="deleteItems"
        >
          <el-button :loading="deleteType" size="mini" slot="reference">删除</el-button>
        </el-popconfirm>

      </div>
      <el-table
          v-loading="tableLoadingType"
          :data="tableData"
          style="width: 100%;"
          row-key="id"
          class="tableListValue"
          ref="table"
          stripe
          :height="tableHeight"
          :tree-props="{children: 'menuChildren'}">
        <el-table-column
            :reserve-selection="true"
            align="center"
            type="selection"
            width="50">
        </el-table-column>
        <el-table-column
            prop="orgName"
            label="机构名称">
        </el-table-column>
        <el-table-column
            prop="orgFullName"
            align="center"
            label="机构全称">
        </el-table-column>
        <el-table-column
            prop="orgType"
            align="center"
            label="机构类型">
          <template slot-scope="scope">
            {{orgTypeObj[scope.row.orgType]}}
          </template>
        </el-table-column>
        <el-table-column
            prop="sort"
            align="center"
            label="排序">
        </el-table-column>
      </el-table>
    </el-card>
    <!--    新增修改弹框-->
    <el-drawer
        :destroy-on-close="true"
        :show-close="false"
        :title="drawerTitle"
        :visible.sync="drawerType"
        direction="rtl"
        size="30%">
      <enterprise-dialog :drawerForm="drawerForm" :dialogType="dialogType"
                         @drawerClose="drawerClose"></enterprise-dialog>
    </el-drawer>
  </div>
</template>

<script>
import {getAreaTree, getAreaData, delArea} from "../../common/enterpriseApi";
import EnterpriseDialog from './components/enterpriseDialog'

export default {
  name: "enterprise",
  components: {
    EnterpriseDialog
  },
  data() {
    return {
      orgTypeObj: {
        0: '公司',
        1: '部门',
      },
      drawerTitle: '',
      drawerType: false,
      deleteType: false,
      dialogType: false,
      tableLoadingType: false,
      drawerForm: {},
      formInline: {},
      tableHeight: 0,
      tableData: []
    }
  },
  mounted() {
    this.$nextTick(function () {
      this.tableHeight =
          window.innerHeight - this.$refs.table.$el.offsetTop - 45
    })
    this.getAreaTree()
  },
  methods: {
    drawerClose() {
      this.getAreaTree()
      this.$refs.table.clearSelection();
      this.drawerType = false
    },
    // 获取列表
    async getAreaTree() {
      this.tableLoadingType = true
      try {
        const res = await getAreaTree({orgName: this.formInline.enterpriseData})
        if (res.code === 200) {
          this.tableData = res.data
          this.tableLoadingType = false
        } else {
          this.tableLoadingType = false
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
      } catch (e) {
        this.tableLoadingType = false
        console.log(e)
      }
    },
    // 删除列表数据
    async deleteItems() {
      const arr = this.$refs.table.selection;
      if (arr.length === 0) {
        this.$notify.error({
          title: '操作错误 !',
          message: '请选择数据后删除 !'
        })
        return
      }
      if (arr.length > 1) {
        this.$notify.error({
          title: '操作错误 !',
          message: '只可选择一条数据删除 !'
        })
        return
      }
      try {
        const ids = []
        for (const el of arr.values()){
          ids.push(el.id)
        }
        this.deleteType = true
        const res = await delArea({ids})
        if (res.code === 200) {
          this.$notify.success({
            title: '成功提示',
            message: '数据删除成功'
          })
          this.$refs.table.clearSelection();
          this.deleteType = false
          this.getAreaTree()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
          this.deleteType = false
        }
      } catch (e) {
        this.deleteType = false
        console.log(e)
      }
    },
    // 新增修改弹框
    async openDrawer(type) {
      this.dialogType = type
      if (type === 1) {
        this.drawerTitle = '新增企业'
        this.drawerForm = {sort: 1}
        this.drawerType = true
      } else {
        const arr = this.$refs.table.selection;
        if (arr.length === 0) {
          this.$notify.error({
            title: '操作错误 !',
            message: '请选择数据后操作 !'
          })
          return
        }
        if (arr.length > 1) {
          this.$notify.error({
            title: '操作错误 !',
            message: '只可选择一条数据后操作 !'
          })
          return
        }
        const res = await getAreaData({id: arr[0].id})
        if (res.code === 200) {
          this.drawerForm = res.data
          this.drawerForm.parentCodes = this.drawerForm.parentCodes.reverse()
        } else {
          this.$notify.error({
            title: '错误提示',
            message: res.msg
          })
        }
        this.drawerTitle = '修改企业'
        this.drawerType = true
      }
    },
    // 搜索重置
    searchTableData(type) {
      if (type === 2) {
        this.formInline = {}
      }
      this.getAreaTree()
    },
  }
}
</script>

<style scoped>
.content-box /deep/ .el-table__placeholder {
  padding-left: 20px;
}

.form-box {
  box-sizing: border-box;
  padding: 0 60px 0 20px;
}

.form-box /deep/ .el-form-item {
  margin-bottom: 10px !important;
}

.top-title {
  text-align: left;
  margin-bottom: 20px;
  margin-top: 20px;
  font-size: 18px;
  font-weight: 700;
}

.bottom-btn {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.pagination {
  margin-top: 10px;
  text-align: right;
}

.box-card {
  text-align: left;
  border-radius: 10px;
  height: 100%;
}
</style>
<style scoped lang="scss">
.tableListValue {
  //滚动条的宽高
  ::-webkit-scrollbar {
    width: 1vh;
    height: 1vh;
  }

  //滚动条的滑块背景色
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 2vh;
  }

  //滚动条的背景色
  ::-webkit-scrollbar-track {
    background: rgba(#ccc, 0.3);
  }

}


/* 设置滚动条的样式 */
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}


/*定义滚动条轨道 内阴影+圆角*/

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  background-color: #F5F5F5;
}


/*定义滑块 内阴影+圆角*/

::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.1);
  background-color: #ccc;

}

</style>
